/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsPages = {
    pagesCurrent: 1,
    pagesLoaded: [],
    pagesTotal: null,
    productsTotal: null,
    pagesSize: window.liveSearchConfig.pagesSize,
    clickedProductSelector: '',
    clickedProductPage: 1,
    /**
     * Set page info
     *
     * @param catalogStore
     * @param result
     */
    setPageInfo(catalogStore, result) {
        const pageInfo = result.productSearch.page_info
        catalogStore.productsTotal = result.productSearch.total_count
        catalogStore.pagesTotal = pageInfo.total_pages
        catalogStore.pagesCurrent = pageInfo.current_page
        this.setPagesLoaded(pageInfo.current_page)
    },
    /**
     * Store the loaded page number
     *
     * @param page
     */
    setPagesLoaded(page) {
        const pagesLoaded = this.pagesLoaded
        if (page > pagesLoaded[pagesLoaded.length - 1]) {
            pagesLoaded.push(page)
        } else {
            pagesLoaded.unshift(page)
        }
        // remove duplicates
        this.pagesLoaded = [...new Set(pagesLoaded)]
    },
    /**
     * Set current page
     */
    setCurrentPage() {
        if (this.clickedProductPage !== 1) {
            this.pagesCurrent = Number(this.clickedProductPage)
        } else {
            this.pagesCurrent = this.getCurrentPageFromUrl()
        }
    },
    /**
     * Handle page state
     * Reset facets and products if category path changes
     * on first visit, if SEO indexed filters are present
     * or if there are facet params in the URL
     */
    handlePageState() {
        if (this.hasSeoIndexedFilters) {
            this.resetFacets()
            this.resetProducts()
            if (!this.seoFilterNoProducts) {
                this.loadFacetsFromSeoIndexedFilters()
            }
            return
        }

        const isFirstVisit = this.lastVisitedCategoryPath === ''
        const hasChangedCategory = this.currentCategoryPath !== this.lastVisitedCategoryPath

        if (isFirstVisit || hasChangedCategory || this.hasFacetParamsInUrl()) {
            this.resetFacets()
            this.resetProducts()
            this.loadFacetsFromUrl()
        }
    },
    /**
     * Check whether the current URL contains non-excluded facet parameters.
     *
     * @returns {boolean}
     */
    hasFacetParamsInUrl() {
        for (const [key] of this.urlParams.entries()) {
            // Pagination parameter is not a filter
            if (key === 'p') {
                continue
            }
            if (this.isFacetAttributeAllowed(this.safeDecode(key))) {
                return true
            }
        }

        return false
    }
}

export default liveSearchProductsPages
